import Vue from "vue";
import Router from "vue-router";
import home from "@/components/index";
//import products from '@/components/products';
import ProductDetail from "@/components/product_detail";
import catProducts from "@/components/category-products";
import deliveryLocations from "@/components/delivery-location";
import contact from "@/components/contact-us";
import how from "@/components/how-to-buy";
import about from "@/components/about";
import termsCondition from "@/components/terms-condition";
import marketerSell from "@/components/marketer-sell";
import depositOrderList from "@/components/deposit-order-list";
import auth from "@/components/auth";
import signup from "@/components/signup";
import myProfile from "@/components/my-profile";
import myorder from "@/components/myorder";
import singleorders from "@/components/singleorder";
import depositHistory from "@/components/deposit-history";
import search from "@/components/search";
import policy from "@/components/policy";
import restaurants from "@/components/restaurants";
import myAccount from "@/components/my-account";
import deposit from "@/components/deposit";
import singleRestaurant from "@/components/singleRestaurant";
import cart from "@/components/cart";
import wishlist from "@/components/wishlist";
import gift from "@/components/gift";
import openJobs from "@/components/open-jobs";
import checkout from "@/components/checkout";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
Vue.use(Router);
export default new Router({
  //remove #  from  url
  mode: "history",
  history: true,
  routes: [
    {
      path: "/open-jobs",
      name: "Open Jobs",
      component: openJobs,
      root: "/"
    },
    {
      path: "/gift",
      name: "Gifts",
      component: gift,
      root: "/"
    },
    {
      path: "/my-account",
      name: "My Account",
      component: myAccount,
      root: "/"
    },
    {
      path: "/delivery-locations",
      name: "Delivery Locations",
      component: deliveryLocations,
      root: "/"
    },
    {
      path: "/restaurant/:id",
      name: "Order Food",
      component: singleRestaurant,
      root: "/"
    },

    {
      path: "/deposit-history",
      name: "Deposit History",
      component: depositHistory,
      root: "/"
    },
    {
      path: "/my-deposit",
      name: "Deposit",
      component: deposit,
      root: "/"
    },
    {
      path: "/deposit-order-list",
      name: "Deposit Order List",
      component: depositOrderList,
      root: "/"
    },

    {
      path: "/restaurants",
      name: "restaurants",
      component: restaurants,
      root: "/"
    },

    {
      path: "/contact-us",
      name: "Contact Us",
      component: contact,
      root: "/"
    },
    {
      path: "/login",
      name: "Login",
      component: auth,
      root: "/"
    },
    {
      path: "/signup",
      name: "Signup",
      component: signup,
      root: "/"
    },
    {
      path: "/my-profile",
      name: "My Profile",
      component: myProfile,
      root: "/"
    },
    {
      path: "/about-us",
      name: "About Us",
      component: about,
      root: "/"
    },
    {
      path: "/terms-condition",
      name: "Terms & Condition",
      component: termsCondition,
      root: "/"
    },
    {
      path: "/how-to-buy",
      name: "How To Buy",
      component: how,
      root: "/"
    },
    {
      path: "/policy",
      name: "Privacy Policy",
      component: policy,
      root: "/"
    },
    {
      path: "/search/:param",
      name: "Product Request",
      component: search,
      root: "/"
    },
    {
      path: "/myorders",
      name: "My Orders",
      component: myorder,
      root: "/"
    },
    {
      path: "/marketer-sells/",
      name: "Marketer Sell",
      component: marketerSell,
      root: "/"
    },
    {
      path: "/myorder/:id",
      name: "singleorder",
      component: singleorders,
      root: "/"
    },
    {
      path: "/",
      name: "Online Shop in Gopalganj City",
      component: home,
      root: "/"
    },
    {
      path: "/cart",
      name: "Cart",
      component: cart,
      root: "/"
    },
    {
      path: "/wishlist",
      name: "Wishlist",
      component: wishlist,
      root: "/"
    },
    {
      path: "/checkout",
      name: "Checkout",
      component: checkout,
      root: "/"
    },
    {
      path: "/product/:slug",
      name: "Product Detail",
      component: ProductDetail,
      root: "/"
    },
    {
      path: "/:slug",
      name: "CategoryProducts",
      component: catProducts,
      root: "/"
    }
  ],
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});

// HTACCESS CONFIGURATION
// <IfModule mod_rewrite.c>
// RewriteEngine On
// RewriteBase /
// RewriteRule ^index\.html$ - [L]
// RewriteCond %{REQUEST_FILENAME} !-f
// RewriteCond %{REQUEST_FILENAME} !-d
// RewriteRule . /index.html [L]
// </IfModule>
